var _path, _path2, _g, _ellipse, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMobWellness(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9832 0.291333C13.2895 0.100645 12.5572 0.100577 11.8635 0.291137L4.2154 2.39195C2.47864 2.86902 1.2749 4.44799 1.2749 6.24908V12.1759C1.2749 17.0231 5.27784 22.0509 11.3204 25.2239C12.3238 25.7507 13.5229 25.7507 14.5261 25.2236C20.5663 22.0497 24.5633 17.0165 24.5633 12.1759V6.2485C24.5633 4.44768 23.36 2.86888 21.6235 2.39156L13.9832 0.291333Z",
    fill: "#65A5FF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_393_5607",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 0,
    width: 24,
    height: 26
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9297 0L1.28125 3.19967V12.1759C1.28125 17.44 6.00227 22.917 12.9297 26C19.8554 22.917 24.5697 17.4328 24.5697 12.1759V3.19967L12.9297 0Z",
    fill: "black"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_393_5607)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0995 4.69144C12.2654 4.69597 12.426 4.72197 12.5817 4.76947H12.5972C12.6077 4.77396 12.6156 4.77893 12.6209 4.78342C12.6791 4.8002 12.7341 4.8191 12.7868 4.8451L12.8869 4.88528C12.9264 4.90419 12.9738 4.9394 13.0001 4.95382C13.0264 4.96776 13.0554 4.98218 13.0791 4.99849C13.3716 4.79783 13.7269 4.68912 14.0929 4.69144C14.2591 4.69144 14.425 4.71251 14.5827 4.76002C15.5546 5.04363 15.9049 6.00081 15.6123 6.83745C15.4464 7.26499 15.1752 7.65519 14.8199 7.97401C14.3115 8.41597 13.7535 8.80829 13.1528 9.14626L13.087 9.18195L13.0185 9.1439C12.4158 8.80829 11.8546 8.41597 11.3414 7.97165C10.9885 7.65283 10.717 7.26499 10.5485 6.83745C10.2509 6.00081 10.6012 5.04363 11.5836 4.75506C11.66 4.73142 11.7387 4.71488 11.8177 4.70566H11.8493C11.9233 4.69597 11.9968 4.69144 12.0705 4.69144H12.0995Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.9976,
    cy: 10.7519,
    rx: 3.2539,
    ry: 3.2539,
    fill: "#111621"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 20.3139,
    cy: 8.5751,
    rx: 1.35439,
    ry: 1.35439,
    fill: "#111621"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7534 20.3931C11.7534 17.1643 14.3708 14.5469 17.5996 14.5469C20.8284 14.5469 23.4458 17.1643 23.4458 20.3931V23.2239H11.7534V20.3931Z",
    fill: "#111621"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.52685,
    cy: 10.7578,
    rx: 3.2539,
    ry: 3.2539,
    fill: "#111621"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.779785 20.3989C0.779785 17.1702 3.39721 14.5527 6.62596 14.5527C9.85472 14.5527 12.4721 17.1702 12.4721 20.3989V23.2298H0.779785V20.3989Z",
    fill: "#111621"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.165 18.8874C14.3631 18.8874 15.3343 17.9161 15.3343 16.7181C15.3343 15.52 14.3631 14.5488 13.165 14.5488C11.967 14.5488 10.9958 15.52 10.9958 16.7181C10.9958 17.9161 11.967 18.8874 13.165 18.8874ZM12.8966 19.4297C10.0513 19.4297 7.74463 21.7363 7.74463 24.5817V25.9375H18.0487V24.5817C18.0487 21.7363 15.742 19.4297 12.8966 19.4297Z",
    fill: "white"
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 4.96611,
    cy: 20.2435,
    rx: 4.96611,
    ry: 4.96611,
    fill: "#00A661"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.96875 17.7637V22.7298",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.48438 20.248H7.45049",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobWellness);
export default __webpack_public_path__ + "static/media/mob-wellness.c0943b83454df260a57e69a8ca91d4d1.svg";
export { ForwardRef as ReactComponent };